import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { sanitizeHtml } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const DatenschutzPage = () => {
  const [html, setHtml] = useState("");
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const v = await api.publicSetting('datenschutz');
        setHtml(sanitizeHtml(v || ''));
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <div className="min-h-[60vh] bg-background">
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="text-2xl font-semibold mb-4">{t('legal.privacyTitle')}</h1>
        {loading ? (
          <div className="text-sm text-muted-foreground">{t('common.loading')}</div>
        ) : html ? (
          <div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <div className="text-sm text-muted-foreground">{t('legal.privacyEmpty')}</div>
        )}
      </main>
    </div>
  );
};

export default DatenschutzPage;
